import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NextStep() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-8 space-y-6">
        {/* From Essential */}
        <div className="border border-accent-500/20 bg-background-50 p-8 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
          {/* Arrow */}
          <div className="flex-shrink-0 flex items-center gap-2">
            <span className="text-[13px] text-foreground-500 tracking-[0.08em] font-label whitespace-nowrap">
              {t('coursesAdvanced.nextStep.fromEssential')}
            </span>
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-arrow-right-line text-accent-500 text-lg"></i>
            </span>
            <span className="text-[13px] text-accent-600 tracking-[0.08em] font-label whitespace-nowrap">
              {t('coursesAdvanced.nextStep.toAdvanced')}
            </span>
          </div>

          {/* Content */}
          <div className="flex-1 text-center md:text-left">
            {String(t('coursesAdvanced.nextStep.descriptionEssential')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-700 leading-relaxed tracking-[0.03em] mb-2">{__s}</p>))}
            <p className="text-[15px] text-accent-700 font-medium tracking-[0.05em]">
              {t('coursesAdvanced.nextStep.discountLabel').replace('{amount}', t('coursesAdvanced.nextStep.discountEssential'))}
            </p>
          </div>

          <div className="flex-shrink-0">
            <Link
              to="/courses/essential"
              className="btn-glow inline-block px-6 py-3 border border-accent-500/50 text-accent-600 hover:text-accent-500 hover:border-accent-400 hover:bg-accent-500/5 text-[14px] tracking-[0.08em] text-center transition-all duration-300 whitespace-nowrap"
            >
              {t('coursesAdvanced.nextStep.viewEssential')}
            </Link>
          </div>
        </div>

        {/* To Master */}
        <div className="border border-accent-500/20 bg-background-50 p-8 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
          {/* Arrow */}
          <div className="flex-shrink-0 flex items-center gap-2">
            <span className="text-[13px] text-accent-600 tracking-[0.08em] font-label whitespace-nowrap">
              {t('coursesAdvanced.nextStep.toAdvanced')}
            </span>
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-arrow-right-line text-accent-500 text-lg"></i>
            </span>
            <span className="text-[13px] text-foreground-500 tracking-[0.08em] font-label whitespace-nowrap">
              {t('coursesAdvanced.nextStep.toMaster')}
            </span>
          </div>

          {/* Content */}
          <div className="flex-1 text-center md:text-left">
            {String(t('coursesAdvanced.nextStep.descriptionMaster')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-700 leading-relaxed tracking-[0.03em] mb-2">{__s}</p>))}
            <p className="text-[15px] text-accent-700 font-medium tracking-[0.05em]">
              {t('coursesAdvanced.nextStep.discountLabel').replace('{amount}', t('coursesAdvanced.nextStep.discountMaster'))}
            </p>
          </div>

          <div className="flex-shrink-0">
            <Link
              to="/courses/master"
              className="btn-glow inline-block px-6 py-3 border border-accent-500/50 text-accent-600 hover:text-accent-500 hover:border-accent-400 hover:bg-accent-500/5 text-[14px] tracking-[0.08em] text-center transition-all duration-300 whitespace-nowrap"
            >
              {t('coursesAdvanced.nextStep.viewMaster')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
